module.exports = {"420117001":"邾城街道","420117002":"阳逻街道","420117003":"仓埠街道","420117004":"汪集街道","420117005":"李集街道","420117006":"三店街道","420117007":"潘塘街道","420117008":"旧街街道","420117009":"双柳街道","420117010":"涨渡湖街道","420117011":"辛冲街道","420117012":"徐古街道","420117102":"凤凰镇","420117400":"道观河风景旅游管理处","420117406":"新洲原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420117.json
// module id = 1710
// module chunks = 0